// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.locale-switcher[data-v-5857a62c] {\r\n  color: white;\n}\r\n", ""]);
// Exports
module.exports = exports;
